import React from 'react'
import Slider from 'react-slick';
import ava01 from '../../assets/images/ava-1.jpg';
import ava02 from '../../assets/images/ava-2.jpg';
import ava03 from '../../assets/images/ava-3.jpg';


const Testimonials = () => {

    const settings = {
        dots:true,
        infinite: true,
        autoplay:true,
        speed:1000,
        swipeToSlide:true,
        autoplaySpeed:2000,
        SlidesToShow:3,

        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ]
    }

  return <Slider {...settings}>
    <div className='testimonial py-4 px-3'>
        <p>
            The trip was absolutely phenomenal! From the breathtaking views to the well-organized itinerary, 
            every moment was unforgettable. Our guide was knowledgeable, friendly, and made sure we were comfortable 
            throughout the journey. I can’t wait to book my next adventure with you!
        </p>

            <div className='d-flex align-items-center gap-4 mt-3'>
                <img src={ava01} className='w-25 h-25 rounded-2' alt="" />
                <div>
                    <h6 className='mb-0 mt-3'>John Doe</h6>
                    <p>Customer, Mountain Trekking Expedition</p>
                </div>
            </div>
    </div>

    <div className='testimonial py-4 px-3'>
        <p>
            I had the most relaxing vacation ever. The team took care of every detail, 
            allowing me to fully unwind. The resort was stunning, the food was delicious, 
            and the planned activities added the perfect balance of excitement. Highly recommend their services!
        </p>

            <div className='d-flex align-items-center gap-4 mt-3'>
                <img src={ava02} className='w-25 h-25 rounded-2' alt="" />
                <div>
                    <h6 className='mb-0 mt-3'>Lia Franklin</h6>
                    <p>Customer, Beach Getaway</p>
                </div>
            </div>
    </div>

    <div className='testimonial py-4 px-3'>
        <p>
            We traveled as a family of four, and everything was catered to both adults and kids alike. 
            The itinerary was fun and engaging, and the travel team ensured we had plenty of memorable moments together. 
            Thank you for making this trip so special!
        </p>

            <div className='d-flex align-items-center gap-4 mt-3'>
                <img src={ava03} className='w-25 h-25 rounded-2' alt="" />
                <div>
                    <h6 className='mb-0 mt-3'>Kevin</h6>
                    <p>Customer, European Vacation</p>
                </div>
            </div>
    </div>

    <div className='testimonial py-4 px-3'>
        <p>
            This tour was a perfect blend of history, culture, and adventure. 
            The guides were experts in their field, making every location come alive with stories. 
            I gained so much knowledge and had an amazing time exploring the world’s wonders.
        </p>

            <div className='d-flex align-items-center gap-4 mt-3'>
                <img src={ava03} className='w-25 h-25 rounded-2' alt="" />
                <div>
                    <h6 className='mb-0 mt-3'>Henry</h6>
                    <p>Customer, Historical Tour of Egypt</p>
                </div>
            </div>
    </div>
  </Slider>
}

export default Testimonials
